import React from 'react';
import ReferralCompleteDialog from '../../dialogs/ReferralCompleteDialog';
import DialogReferralNotes from '../../dialogs/DialogReferralNotes';
import SetAppointmentReferralDialog from '../../dialogs/SetAppointmentReferralDialog';
import UpdateMiniReferralDialog from '../../dialogs/UpdateMiniReferralDialog';
import UpdateReferralSentDateDialog from '../../dialogs/UpdateReferralSentDateDialog';

export default function ActiveReferralBaseDialogs({
  history,
  dialogs,
  isReceived = false,
}) {
  return (
    <>
      <DialogReferralNotes
        referralUuid={dialogs.referralUuid}
        openNotes={dialogs.openNotes}
        handleClose={() => dialogs.setOpenNotes(false)}
        isExternal={false}
      />

      <ReferralCompleteDialog
        initialAppointmentDate={dialogs.appointmentDate}
        initialOpen={dialogs.openCompleteDialog}
        referralUuid={dialogs.referralUuid}
        onPromoteReferral={dialogs.onPromoteReferral}
        onClose={() => dialogs.setOpenCompleteDialog(false)}
      />

      <UpdateMiniReferralDialog
        open={dialogs.openReferralDialog}
        onClose={dialogs.closeAndRefreshReferralDialog}
        referral={dialogs.referral}
        isPublicPatient
        isReceived={isReceived}
      />

      <UpdateReferralSentDateDialog
        open={dialogs.openSentDateDialog}
        onClose={dialogs.closeAndRefreshSentDateDialog}
        referral={dialogs.referral}
        isReceived={isReceived}
      />

      <SetAppointmentReferralDialog
        onOpen={dialogs.openAppointmentDialog}
        onClose={dialogs.closeAndRefreshAppointmentDialog}
        history={history}
        uuid={dialogs.referralUuid}
        status={dialogs.status}
        appointmentDate={dialogs.scheduleAppointmentDate}
        reschedule={Boolean(dialogs.scheduleAppointmentDate)}
      />
    </>
  );
}
